import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  LabelQueryCriteriaClass,
  LabelCriteriaModelQuery,
} from "../../criteria";
import { Core2Config, ApiVisa, ApiResponseModel } from "../shared";
import { BaseApiPublicLoginTemplateService } from "../shared/base-api-public-login-template.service";
import { WMSItemLabelListContainerModel } from "../../../../../models/aggregates/warehouse/index";

@Injectable({
  providedIn: "root",
})
export class WMSItemLabelListService extends BaseApiPublicLoginTemplateService<
  WMSItemLabelListContainerModel,
  WMSItemLabelListContainerModel,
  WMSItemLabelListContainerModel
> {
  readonly url =
    Core2Config.DOMAIN_TEST_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    "wms-item-label-lists";
  static readonly LABEL_LIST_SUB_PATH =
    "wms-item-label-lists/" + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_TEST_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-label-lists/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-label-lists/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
    this.endpoint_path_public_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-label-lists/" +
      BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-label-lists/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
  }
  getByCriteriaObservable(
    visa: ApiVisa,
    criteria?: LabelQueryCriteriaClass
  ): Observable<ApiResponseModel<WMSItemLabelListContainerModel>> {
    const buildDocCriteria = new LabelCriteriaModelQuery(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + "/query?" + buildDocCriteria.query;
    return this.httpClient.get<
      ApiResponseModel<WMSItemLabelListContainerModel>
    >(UrlByCriteria, this.getHttpHeader(visa));
  }
}
